var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AbstractCarModal',_vm._g(_vm._b({scopedSlots:_vm._u([{key:"form-extension",fn:function(ref){
var entity = ref.entity;
return [_c('DriverField',{attrs:{"required":"","rules":[_vm.rules.required],"icon":null},model:{value:(entity.user),callback:function ($$v) {_vm.$set(entity, "user", $$v)},expression:"entity.user"}})]}}])},'AbstractCarModal',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }